<template>
    <div id="allmap" class="allmap" />
</template>

<script>
import { BMapLoader } from "@/utils/map.js";
export default {
    name: "BMap",
    data() {
        return {
            map: null,
            datalist: [[{
                longitude: "120.210869",
                dimension: "30.35657"
            }]],
        };
    },
    created() { },
    mounted() {

        this.initMap();
    },
    destroyed() {
        this.map.destroy();
    },
    methods: {
        initMap() {
            this.$nextTick(() => {
                BMapLoader("zAFjuNLCPqtPr9X4BtPNmGh2mjT8Fyum").then((BMap) => {
                    console.log(BMap, "6454545");
                    const map = new BMap.Map("allmap", { enableMapClick: false });
                    this.map = map;
                    map.disableKeyboard(); // 禁用键盘操作地图
                    map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
                    // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
                    if (this.datalist.length > 0) {
                        var point = new BMap.Point(
                            120.210869,
                            30.35657
                        );
                    }
                    map.centerAndZoom(point, 13);
                    this.addMarker(BMap, map);
                });
            });
        },
        addMarker(BMap, map) {
            console.log(BMap, "gggg");
            console.log(map, "gggg");
            for (var i = 0; i < this.datalist.length; i++) {
                const point = new BMap.Point(
                    120.210869,
                    30.35657
                );
                var marker = new BMap.Marker(point); // 创建标注
                var content = '浙江省杭州市上城区丁兰街道临丁路1190号8楼826室';
                var label = new BMapGL.Label(content, {       // 创建文本标注
                    position: point,
                    offset: new BMapGL.Size(10, 20)
                })
                map.addOverlay(label);                        // 将标注添加到地图中
                label.setStyle({                              // 设置label的样式
                    color: '#333',
                    fontSize: '15px',
                    border: '2px solid #FFF',
                    fontWeight: '500',
                    borderRadius: '10px',
                    padding: '10px',
                    boxShadow: '0px 0px 18px 0px rgba(34,33,34,0.23)'
                    // background: 'rgba(255,255,255,0.5)',
                })
                // 创建信息窗口
                let opts = {
                    width: 100,
                    height: 50,
                    title: "",
                    offset: new BMap.Size(0, -28),
                    message: "浙江省杭州市上城区丁兰街道临丁路1190号8楼826室",
                };
                let infoWindow = new BMap.InfoWindow(
                    "浙江省杭州市上城区丁兰街道临丁路1190号8楼826室",
                    opts
                ); // 将传值名称加入地图
                map.addOverlay(marker);
                // marker.setLabel(label);
                //标记的点击事件
                marker.addEventListener("mouseover", function () {
                    map.openInfoWindow(infoWindow, point);
                });
                //鼠标划出发生的事件
                marker.addEventListener("mouseout", function () {
                    map.closeInfoWindow((infoWindow, point));
                });
            }
        },

    },
};
</script>
<style lang="scss" scoped>
.allmap {
    width: 1200px;
    height: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -30px;
}
</style>